awardCalculation.classy.controller({
    name: 'LeftAwardCalculationController',
    inject: ['$scope', 'AlertService', 'ApplicationService', 'authServiceFactory', '$state', 'SchoolModelService', 'SliderService', 'SliderFactory'],
    init: function ()
    {
        this.$.School_Country = this.SchoolModelService.get()[0].School_Country;
        this.$.AlertService = this.AlertService;
        this.$.SliderService = this.SliderService;
        this.$.$state = this.$state;
    },
    getBallClass: function(alertName)
    {
        var alert = this.AlertService.getAlerts()[alertName];
        if (alert.fired == true && alert.complete == 1)
            return 'text-' + alert.stateType;
        else
        {
            if (alert.state == "disabled" || alert.state == "void")
                return 'text-success';
            return 'text-' + alert.state;
        }
    },
    budgetsShow: function()
    {
        if (this.ApplicationService.getAwardData().applicants[0].budgets.length == 0)
            return false;
        else
        {
            for (var i = 0; i < this.ApplicationService.getAwardData().applicants.length; i++)
                if (this.ApplicationService.getAwardData().applicants[i] != 0.00)
                    return true;
        }
    },
    getIncomeBallClass: function()
    {
        if (this.ApplicationService.getAwardData().app[0].Tax_State==null)
            return 'text-danger';
        else if (this.$.getBallClass('lowIncomeDetected') == 'text-warning')
            return 'text-warning';
        else if (this.$.getBallClass('homemakerDetected') == 'text-warning')
            return 'text-warning';
        else if (this.$.getBallClass('businessIncomeReported') == 'text-warning')
            return 'text-warning';
        else
            return 'text-success';
    },
    getTaxBallClass: function()
    {
        if (this.ApplicationService.getAwardData().app[0].Tax_State==null)
            return 'text-danger';
        else if (this.ApplicationService.getAwardData().app[0].Tax_State==3)
            return 'text-warning';
        else if (this.ApplicationService.getAwardData().app[0].Tax_State==5)
            return 'text-pending';
        else if (this.ApplicationService.getAwardData().app[0].Tax_State==1 || this.ApplicationService.getAwardData().app[0].Tax_State==2)
            return 'text-success';
    },
    getInsuranceBallClass: function()
    {
        if (this.$.getBallClass('autoInsuranceThresholdExceeded') == 'text-warning')
            return 'text-warning';
        else if (this.$.getBallClass('lifeInsuranceThresholdExceeded') == 'text-warning')
            return 'text-warning';
        else
            return 'text-success';
    },
    getLivingAllowanceBallClass: function()
    {
        if (this.$.getBallClass('otherTuitionReported') == 'text-warning')
            return 'text-warning';
        else if (this.$.getBallClass('collegeTuitionReported') == 'text-warning')
            return 'text-warning';
        else
            return 'text-success';
    },
    hasAlertsClass: function()
    {
        for (var key in this.AlertService.getAlerts()) {
            var ballClass = this.$.getBallClass(key);
            if (ballClass == "text-warning" || ballClass == "text-danger")
                return "text-warning";
        }
        return "text-success";
    },
    setPartial: function(partial, header)
    {
        this.SliderService.pushSlider(new this.SliderFactory(partial, header, 's'));
    }

});
